import { register } from '@shopify/theme-sections';
import '../styles/templates/customers/login-register.scss';

register('login-register', {
    onLoad() {
        console.log("LOADED");
        /**
         * Password Template Script
         * ------------------------------------------------------------------------------
         * A file that contains scripts highly couple code to the Password template.
         *
         * @namespace password
         */

        const selectors = {
            recoverPasswordFormTriggers: '[data-recover-toggle]',
            recoverPasswordForm: '[data-recover-form]',
            loginForm: '[data-login-form]',
            formState: '[data-form-state]',
            resetSuccess: '[data-reset-success]',
        };

        function onShowHidePasswordForm(evt) {
            evt.preventDefault();
            toggleRecoverPasswordForm();
        }

        function checkUrlHash() {
            const hash = window.location.hash;

            // Allow deep linking to recover password form
            if (hash === '#recover') {
            toggleRecoverPasswordForm();
            }
        }

        /**
         *  Show/Hide recover password form
         */
        function toggleRecoverPasswordForm() {
            document.querySelector(selectors.recoverPasswordForm).classList.toggle('hide');
            document.querySelector(selectors.loginForm).classList.toggle('hide');
        }

        /**
         *  Show reset password success message
         */
        function resetPasswordSuccess() {
            // check if reset password form was
            // successfully submitted and show success message.

            if (document.querySelector(selectors.formState)) {
            document.querySelector(selectors.resetSuccess).classList.remove('hide');
            }
        }

        if (document.querySelector(selectors.recoverPasswordForm)) {
            checkUrlHash();
            resetPasswordSuccess();

            document.querySelectorAll(selectors.recoverPasswordFormTriggers).forEach((trigger) => {
            trigger.addEventListener('click', onShowHidePasswordForm);
            });
        }

        document.addEventListener('DOMContentLoaded', () => {
            const tabButtons = document.querySelectorAll('.account__tab-button');
            const tabContents = document.querySelectorAll('.account__tab-content');
            const buttonActiveClass = 'account__tab-button-wrapper--active';
            const contentActiveClass = 'account__tab-content--active';
            if (tabButtons) {
                tabButtons.forEach((button) => {
                    button.addEventListener('click', (event) => {
                        const buttonWrapper = button.parentElement;
                        const formType = button.dataset.form;
                        if (buttonWrapper && !buttonWrapper.classList.contains(buttonActiveClass)) {
                            tabButtons.forEach((elem) => {
                                const parent = elem.parentElement;
                                if (parent && parent.classList.contains(buttonActiveClass)) {
                                    parent.classList.remove(buttonActiveClass);
                                }
                            });
                            buttonWrapper.classList.add(buttonActiveClass);

                            tabContents.forEach((elem) => {
                                elem.classList.remove(contentActiveClass);
                            });
                            const selected = document.querySelector(`#account__${formType}`);
                            if (selected) {
                                selected.classList.add(contentActiveClass);
                            }
                        }
                    });
                });
            }
        });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload() {
      this.$container.off(this.namespace);
    },
});
